export default "<div [chart]=\"batteryInstant\"></div>"